<template>
  <div id="app" v-if="menuDataReady">
    <div class="appWrap fill-parent">
      <div class="right-container">
        <!-- <div class="top-content">
          <navigation-top @on-select-account="onSelectAccount" />
        </div> -->
        <div class="main-content">
          <div class="body-view">
            <!-- <div class="left-view">
              <div class="user-msg">
                <div class="msg-left">
                  <img
                    class="user-avatar"
                    src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                  />
                </div>
                <div class="msg-right">
                  <div class="user-name">
                    <span>{{commonData.USERNAME}}</span>
                    <span class="edit-icon el-icon-edit"></span>
                  </div>
                  <div class="user-level">
                    <span>{{commonData.ROLENAME}}</span>
                  </div>
                </div>
              </div>
              <div class="user-msg-list">
                <div class="msg-list">
                  <div class="inputbox el-icon-phone">
                    <input
                      v-model="model.username"
                      autocomplete="off"
                      placeholder
                      class="username full"
                      type="text"
                    />
                  </div>
                  <span class="edit-icon el-icon-edit"></span>
                </div>
                <div class="msg-list">
                  <div class="inputbox kebai-icons-lock">
                    <input
                      v-model="model.username"
                      autocomplete="off"
                      placeholder
                      class="username full"
                      type="password"
                    />
                  </div>
                  <span class="edit-icon el-icon-edit"></span>
                </div>
                <div class="msg-list">
                  <div class="inputbox el-icon-message">
                    <input
                      v-model="model.username"
                      autocomplete="off"
                      placeholder
                      class="username full"
                      type="text"
                    />
                  </div>
                  <span class="edit-icon el-icon-edit"></span>
                </div>
              </div>
              <div class="btn-view">
                <div class="list-btn">
                  <div class="inputbox" style="margin-top: 40px;">
                    <input class="button button-login submit full" value="修改密码" type="button" />
                  </div>
                </div>
                <div class="list-btn">
                  <div class="inputbox" style="margin-top: 20px;" @click="clickLogout">
                    <input class="button button-login signout full" value="注销登录" type="button" />
                  </div>
                </div>
              </div>
            </div>-->
            <!-- <div class="top-view">济南市十大特色产业“莱芜生姜”大数据中心</div> -->
            <!-- <div class="right-view">
              <div
                :class="`list-row ${!item.isDisabled ?'list-row-hover' :''}`"
                v-for="(item, index) in systemArr"
                :key="index"
              >
                <div class="left-content">
                  <img class="img-src" :src="item.imgsrc" alt />
                </div>
                <div class="right-content">
                  <div class="title-name">
                    <span>{{ item.name }}</span>
                  </div>
                  <div class="describe-content">
                      <span>{{item.describe}}</span>
                  </div>
                  <div
                    :class="`enter-system ${
                      item.isDisabled ? 'isDisabled' : ''
                    }`"
                    @click="linkSso(item)"
                  >
                    <span class="btn-span">进入系统</span>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- <div class="login-footer">
              <p class="p-height">
                Copyright©1999-2020 中国移动 版权所有 本网站支持IPv6访问
              </p>
              <p class="p-height">
                中华人民共和国增值电信业务经营许可证
                经营许可证编号：A2.B1.B2-20100001
              </p>
              <p class="p-height marginTop">
                技术支持：中国移动通信集团有限公司
              </p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationTop from "@/components/navigation/top.vue";
import ApiRequest from "./api-main";
import CommonData from "@/services/model/common-data";
import pathConfig from "@/config/pathConfig";

export default {
  components: {
    NavigationTop,
  },
  data() {
    return {
      commonData: new CommonData(this),
      apiRequest: new ApiRequest(this),
      menuDataReady: true,
      isFirstLoad: true,
      model: {
        username: "",
        password: null,
      },
      systemArr: [
        {
          name: "物联网平台",
          type: 3,
          isclick: true,
          imgsrc: require("@/assets/images/wulianwang.png"),
          path: pathConfig.quwoCloud,
        },
        {
          name: "权限管理",
          type: 5,
          isclick: true,
          imgsrc: require("@/assets/images/quanxian.png"),
          path: pathConfig.febs,
        },
        {
          name: "业务管理",
          type: 6,
          isclick: true,
          imgsrc: require("@/assets/images/yewu.png"),
          path: pathConfig.system,
        },
        // {
        //   name: "大数据管理",
        //   type: 4,
        //   isclick: true,
        //   imgsrc: require("@/assets/images/houtai.png"),
        //   path: pathConfig.quwoback,
        //   isDisabled: true,
        // },
      ],
    };
  },
  computed: {},
  mounted() {
    let that = this;
    // window.loading(false);
    this.checkToken();
  },
  methods: {
    checkToken() {
      console.log("token", this.$localStorage.get("access_token"));
      const token = this.$localStorage.get("access_token");
      if (!token)
        window.location.href = window.prePath + "/index.html?web#/login";
      else window.location.href = '/cloud/main.html';
    },

    queryLandAreaList() {
      this.apiRequest.queryLandAreaList().then((res) => {
        console.log("gogoggo");
      });
    },
    onSelectAccount() {
      window.location.reload();
    },
    linkSso(data) {
      if (data.isclick) {
        window.location.href = data.path;
      } 
      // else {
      //   this.$message({
      //     message: "平台正在建设中。。。",
      //     type: "warning",
      //   });
      // }
      // window.open(path);
    },
    clickLogout() {
      localStorage.clear();
      window.location.href = window.backPath;
    },
  },
  watch: {},
};
</script>

<style lang="scss">
@import "./../../components-base/element-rewrite/_index.scss";
</style>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
/*滚动条样式修改*/
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #d0d0d0;
}
.appWrap {
  height: 100%;
  display: flex;
  user-select: none;
  // background: url("~@/assets/images/pagesbj.png") no-repeat;
  // background-size: 100% 100%;
  background-color: #f5f5f5;
  .left-container {
    width: 60px;
    height: 100%;
  }
  .right-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    .top-content {
      height: 60px;
      // background: url("~@/assets/images/headerbj.png") no-repeat;
      // background-size: 100% 100%;
      background-color: #283343;
      // box-shadow: 0 4px 0 rgba(0, 0, 0, 0.3);
    }
    .main-content {
      width: 100%;
      height: calc(100% - 60px);
      overflow: hidden;
      .body-view {
        box-sizing: border-box;
        // padding: 28px 60px 0 60px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        height: 100%;
        overflow: auto;
        .left-view {
          width: 360px;
          margin-right: 40px;
          height: 540px;
          padding: 32px 34px;
          background-color: rgba(51, 51, 51, 0.5);
          border-radius: 0 0 4px 4px;
          overflow: hidden;
          .user-msg {
            display: flex;
            align-items: center;
            .msg-left {
              width: 82px;
              height: 82px;
              border: 4px solid #878787;
              border-radius: 40px;
              overflow: hidden;
              .user-avatar {
                width: 74px;
                height: 74px;
              }
            }
            .msg-right {
              flex: 1;
              margin-left: 10px;
              .user-name {
                color: #ffffff;
                font-size: 17px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .edit-icon {
                  cursor: pointer;
                  color: #999;
                }
              }
              .user-level {
                margin-top: 8px;
                font-size: 15px;
                color: #02aa9f;
              }
            }
          }
          .user-msg-list {
            margin-top: 30px;
            .msg-list {
              height: 55px;
              border-bottom: 2px solid #3a3a3a;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .edit-icon {
                cursor: pointer;
                color: #999;
                font-size: 17px;
              }
              .inputbox {
                position: relative;
                display: inline-flex;
                justify-content: space-between;
                line-height: 30px;
                height: 30px;
                text-align: center;
                &::before {
                  position: absolute;
                  color: #c6c6c6;
                  font-size: 20px;
                  left: 0px;
                  top: 0px;
                  box-sizing: border-box;
                  width: 30px;
                  height: 30px;
                  line-height: 30px;
                }
                input {
                  color: #666666;
                  background: transparent;
                  background-color: transparent;
                  outline: none;
                  line-height: 30px;
                  font-size: 14px;
                  border-radius: 4px;
                  vertical-align: middle;
                  border: 0;
                }
                input[type="text"],
                input[type="password"] {
                  padding-left: 40px;
                  letter-spacing: 1px;
                  box-sizing: border-box;
                  outline: none;
                }
              }
            }
          }
          .btn-view {
            width: 100%;
            .list-btn {
              width: 100%;
            }
            .inputbox {
              position: relative;
              display: inline-flex;
              width: 100%;
              justify-content: space-between;
              line-height: 30px;
              height: 30px;
              text-align: center;
              .full {
                width: 100%;
              }
            }
            input {
              color: #e3e3e3;
              background: #606060;
              background-color: #606060;
              outline: none;
              line-height: 30px;
              font-size: 14px;
              border-radius: 4px;
              vertical-align: middle;
              border: 0;
            }
            input[type="button"] {
              cursor: pointer;
              border: 1px solid #606060;
            }
            input[type="button"].signout {
              background-color: #00b2a6;
              border: 1px solid #00b2a6;
            }
          }
        }
        .top-view {
          width: 100%;
          height: 97px;
          color: #333;
          font-size: 32px;
          text-align: center;
          line-height: 97px;
        }
        .right-view {
          width: 66%;
          // background-color: rgba(51, 51, 51, 0.5);
          // padding: 25px 40px 0 40px;
          // min-height: 730px;
          // overflow: hidden;
          // overflow-y: auto;
          display: flex;
          flex-wrap: wrap;
          // justify-content: center;
          align-content: center;
          .list-row {
            // margin-bottom: 26px;
            width: 394px;
            height: 260px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background: #ffffff;
            margin: 0 12px 32px 12px;
            transition: box-shadow 0.4s, transform 0.4s;
            border-radius: 4px;
            .left-content {
              // width: 100%;
              // height: 100%;
              // border-radius: 7px;
              margin-bottom: 19px;
              // overflow: hidden;
              .img-src {
                // width: 100%;
                // height: 141px;
              }
            }
            .right-content {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              padding-bottom: 10px;
              .title-name {
                font-size: 18px;
                color: #333;
              }
              .describe-content {
                font-size: 12px;
                color: #999;
                line-height: 17px;
              }
              .enter-system {
                margin-top: 19px;
                width: 148px;
                height: 40px;
                line-height: 40px;
                color: #333;
                font-size: 14px;
                text-align: center;
                border: 1px solid #707070;
                border-radius: 4px;
                cursor: pointer;
                .lockBg {
                  width: 30px;
                  height: 30px;
                }
              }
              .isDisabled {
                background: #c6c7c7;
                border: 1px solid  #c6c7c7;
                cursor: not-allowed;
              }
            }
          }
          .list-row-hover:hover {
            transform: translateY(-2%);
            box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.53);
            .enter-system {
              background-color: #283343;
              border: 1px solid #283343;
              color: #ffffff;
            }
          }
        }
        .login-footer {
          height: 67px;
          margin-top: 24px;
          margin-bottom: 35px;
          font-size: 12px;
          color: #8c8c8c;
          width: 100%;
          text-align: center;
          .p-height {
            margin: 0;
            line-height: 17px;
          }
          .marginTop {
            // margin-top: 40px;
          }
        }
      }
    }
  }
}
</style>